import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {NgIf} from '@angular/common';

/**
 * @class
 * @description This class maintains the confirmation dialog for the application.
 * @export
 * @name ConfirmationDialogComponent
 */
@Component({
  selector: 'app-dialog-confirmation',
  styleUrl: './confirmation.component.scss',
  templateUrl: './confirmation.component.html',
  imports: [
    MatDialogClose,
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    NgIf
  ],
  standalone: true
})
export class ConfirmationDialogComponent {

  /**
   * @constructor
   * @description Constructor for the ConfirmationDialogComponent.
   * @memberof ConfirmationDialogComponent
   * @name ConfirmationDialogComponent#constructor
   * @param {MatDialogRef<ConfirmationDialogComponent>} reference The reference to the dialog.
   * @param {{ cancelText?: string, confirmText?: string, title: string, message: string }} data The data for the dialog.
   * @public
   */
  constructor(
    /**
     * @description The reference to the dialog.
     * @memberof ConfirmationDialogComponent
     * @name ConfirmationDialogComponent#reference
     * @property
     * @public
     * @type {MatDialogRef<ConfirmationDialogComponent>}
     */
    public reference: MatDialogRef<ConfirmationDialogComponent>,
    /**
     * @description The data for the dialog.
     * @memberof ConfirmationDialogComponent
     * @name ConfirmationDialogComponent#data
     * @property
     * @public
     * @type {{
     *    cancelText?: string,
     *    confirmText?: string,
     *    displayCancelButton?: boolean,
     *    displayConfirmButton?: boolean,
     *    title: string,
     *    message: string
     * }}
     */
    @Inject(MAT_DIALOG_DATA) public data: {
      cancelText?: string,
      confirmText?: string,
      displayCancelButton?: boolean,
      displayConfirmButton?: boolean,
      title: string,
      message: string
    }
  ) {

    // Ensure we have cancel text.
    this.data.cancelText = this.data.cancelText ?? 'No';

    // Ensure we have confirmation text.
    this.data.confirmText = this.data.confirmText ?? 'Yes';

    // Ensure we have display cancel button.
    this.data.displayCancelButton = this.data.displayCancelButton ?? true;

    // Ensure we have display confirm button.
    this.data.displayConfirmButton = this.data.displayConfirmButton ?? true;
  }
}
